import { render } from "./TheHeader.vue?vue&type=template&id=06ffd8b1&bindings={}"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script